const buildChannelRankGradient = (hexColor: string): string => {
  const normalized = hexColor.replace('#', '').toUpperCase();
  // Figma stops: 40% opacity at 0%, solid at 100% (66 ~= 40% alpha in 8-digit hex).
  return `linear-gradient(90deg, #${normalized}66 0%, #${normalized}FF 100%)`;
};

// Channel bar colors are fixed by name (not rank order); keys use normalizeChannelKey.
const LIVE_TITLE_CHANNEL_COLOR_MAP: Record<string, string> = {
  steam: buildChannelRankGradient('#3E617F'),
  officialwebsite: buildChannelRankGradient('#F19E55'),
  kakao: buildChannelRankGradient('#F8C800'),
  hotcool: buildChannelRankGradient('#CE2A22'),
  epic: buildChannelRankGradient('#5EC8F1'),
  playstation: buildChannelRankGradient('#0070D1'),
  xbox: buildChannelRankGradient('#21CE99'),
};

// Fallback for channels outside the Figma palette (e.g. Standalone Client).
const DEFAULT_LIVE_TITLE_CHANNEL_COLOR = buildChannelRankGradient('#6E7794');

// Collapse API label variants ("KaKao", "Official Website") to one lookup key.
const normalizeChannelKey = (channelName: string): string => {
  return channelName.toLowerCase().replace(/[^a-z0-9]/g, '');
};

export const resolveLiveTitleChannelColor = (channelName: string): string => {
  const key = normalizeChannelKey(channelName);
  return LIVE_TITLE_CHANNEL_COLOR_MAP[key] || DEFAULT_LIVE_TITLE_CHANNEL_COLOR;
};
